// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--ca-text-primary, #202938);
}

.success-dialog {
  box-sizing: border-box;
  width: 100%;
  max-width: 32rem;
  padding: 0.75rem 1rem 1rem;
  text-align: center;
  color: var(--ca-text-primary, #202938);
  background: var(--ca-surface, #ffffff);
}

.success-dialog__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-success, #198754);
  border-radius: 50%;
  background-color: var(--ca-success-bg, #eaf7f0);
}

.success-dialog__icon {
  display: block;
  color: var(--ca-success, #198754);
  font-size: 2.25rem;
  line-height: 1;
}

.success-dialog__content {
  margin: 0 auto;
  max-width: 27rem;
}

.success-dialog__title {
  margin: 0 0 0.625rem;
  color: var(--ca-text-primary, #202938);
  font-size: clamp(1.4rem, 3vw, 1.7rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;
}

.success-dialog__message {
  margin: 0;
  color: var(--ca-text-secondary, #5c6675);
  font-size: 1rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.success-dialog__actions {
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;
}

.success-dialog__button {
  min-width: 7rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.75rem;
  border: 1px solid var(--ca-primary, #0060d6);
  border-radius: var(--ca-radius-md, 0.5rem);
  background-color: var(--ca-primary, #0060d6);
  color: #ffffff;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.success-dialog__button:hover {
  border-color: var(--ca-primary-dark, #1a1a86);
  background-color: var(--ca-primary-dark, #1a1a86);
}

.success-dialog__button:active {
  transform: translateY(1px);
}

.success-dialog__button:focus-visible {
  outline: 3px solid var(--ca-primary-light, #b8d8ff);
  outline-offset: 3px;
  box-shadow: 0 0 0 4px rgba(0, 96, 214, 0.14);
}

@media (max-width: 480px) {
  .success-dialog {
    padding: 0.25rem 0.25rem 0.5rem;
  }
  .success-dialog__icon-wrap {
    width: 3.75rem;
    height: 3.75rem;
    margin-bottom: 1rem;
  }
  .success-dialog__icon {
    font-size: 1.9rem;
  }
  .success-dialog__message {
    font-size: 0.9375rem;
  }
  .success-dialog__actions {
    margin-top: 1.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/success-dialog/success-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sCAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,sCAAA;EACA,sCAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,4CAAA;EACA,kBAAA;EACA,+CAAA;AACF;;AAEA;EACE,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sCAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,0CAAA;EACA,4CAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yGACE;AAAJ;;AAMA;EACE,6CAAA;EACA,iDAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,mDAAA;EACA,mBAAA;EACA,4CAAA;AAHF;;AAMA;EACE;IACE,+BAAA;EAHF;EAMA;IACE,cAAA;IACA,eAAA;IACA,mBAAA;EAJF;EAOA;IACE,iBAAA;EALF;EAQA;IACE,oBAAA;EANF;EASA;IACE,kBAAA;EAPF;AACF","sourcesContent":[":host {\n  display: block;\n  color: var(--ca-text-primary, #202938);\n}\n\n.success-dialog {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 32rem;\n  padding: 0.75rem 1rem 1rem;\n  text-align: center;\n  color: var(--ca-text-primary, #202938);\n  background: var(--ca-surface, #ffffff);\n}\n\n.success-dialog__icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1.25rem;\n  border: 1px solid var(--ca-success, #198754);\n  border-radius: 50%;\n  background-color: var(--ca-success-bg, #eaf7f0);\n}\n\n.success-dialog__icon {\n  display: block;\n  color: var(--ca-success, #198754);\n  font-size: 2.25rem;\n  line-height: 1;\n}\n\n.success-dialog__content {\n  margin: 0 auto;\n  max-width: 27rem;\n}\n\n.success-dialog__title {\n  margin: 0 0 0.625rem;\n  color: var(--ca-text-primary, #202938);\n  font-size: clamp(1.4rem, 3vw, 1.7rem);\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.015em;\n}\n\n.success-dialog__message {\n  margin: 0;\n  color: var(--ca-text-secondary, #5c6675);\n  font-size: 1rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.success-dialog__actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.75rem;\n}\n\n.success-dialog__button {\n  min-width: 7rem;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.75rem;\n  border: 1px solid var(--ca-primary, #0060d6);\n  border-radius: var(--ca-radius-md, 0.5rem);\n  background-color: var(--ca-primary, #0060d6);\n  color: #ffffff;\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.2s ease;\n}\n\n.success-dialog__button:hover {\n  border-color: var(--ca-primary-dark, #1a1a86);\n  background-color: var(--ca-primary-dark, #1a1a86);\n}\n\n.success-dialog__button:active {\n  transform: translateY(1px);\n}\n\n.success-dialog__button:focus-visible {\n  outline: 3px solid var(--ca-primary-light, #b8d8ff);\n  outline-offset: 3px;\n  box-shadow: 0 0 0 4px rgba(0, 96, 214, 0.14);\n}\n\n@media (max-width: 480px) {\n  .success-dialog {\n    padding: 0.25rem 0.25rem 0.5rem;\n  }\n\n  .success-dialog__icon-wrap {\n    width: 3.75rem;\n    height: 3.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .success-dialog__icon {\n    font-size: 1.9rem;\n  }\n\n  .success-dialog__message {\n    font-size: 0.9375rem;\n  }\n\n  .success-dialog__actions {\n    margin-top: 1.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
